import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "assets/vendors/style";
import "styles/wieldy.less";

import store from "./appRedux/store"; // no more history
import App from "./containers/App/index";
import ErrorBoundary from "./ErrorBoundary";
import NavigationHandler from "./containers/Common/Configuration/NavigationHandler";
import DocumentTitleUpdater from "./components/DocumentTitleUpdater";

class NextApp extends React.Component {
  errorHandler = async (error, stackTrace) => {
    console.log(error, stackTrace);
  };

  render() {
    return (
      <ErrorBoundary onError={this.errorHandler}>
        <Provider store={store}>
          <BrowserRouter>
            <DocumentTitleUpdater />
            <NavigationHandler />
            <Routes>
              <Route path="/*" element={<App />} />
            </Routes>
          </BrowserRouter>
        </Provider>
      </ErrorBoundary>
    );
  }
}

export default NextApp;
